/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AgentDetails } from './agentDetails';
import { AgentResource } from './agentResource';


export interface PairingInfo { 
    agent?: AgentDetails;
    /**
     * Org Id
     */
    org_id?: string;
    /**
     * Provider ID in format: <res-type>-<res-id>
     */
    provider_id?: string;
    resource?: AgentResource;
}

